import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Fixed } from 'rebass';
import styled from 'styled-components';
import Work from '../../Work';
import Sidebar from '../../Sidebar';
import FullHeight from '../../app/components/full_height';
import em from '../../app/utils/em';
import clients from '../clients';
import hellothere from './images/hellothere.png';

const sidebarWidth = 16.4; // em
const detailsWidth = 41.2; // em

const finalClients = [
  {
    id: 'home',
    image: hellothere,
    bg: 'brand',
    path: '/',
  },
  ...clients,
];

const FixedFullHeight = FullHeight.withComponent(Fixed);

const Content = styled(Flex)`
  min-height: 100vh;
`;

const DetailsWrapper = styled(Box)`
  flex: 0 0 ${em(detailsWidth)};
`;

const DesktopLayout = ({ children }) => (
  <div>
    <FixedFullHeight
      top
      left
      w={em(sidebarWidth)}
      z={2}
      bg="white"
    >
      <Sidebar />
    </FixedFullHeight>
    <Content
      ml={em(sidebarWidth)}
      align="stretch"
      justify="space-around"
    >
      <Box flex="1">
        <Work clients={finalClients} />
      </Box>
      <DetailsWrapper bg="white">
        {children()}
      </DetailsWrapper>
    </Content>
  </div>
);

DesktopLayout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.shape({ // eslint-disable-line react/no-unused-prop-types
    pathname: PropTypes.string,
  }).isRequired,
};

DesktopLayout.defaultProps = {
  children: null,
};

export default DesktopLayout;



// WEBPACK FOOTER //
// ./src/layouts/desktop/index.js